import { Component, OnDestroy, OnInit } from '@angular/core'
import { MatSnackBar } from '@angular/material/snack-bar'
import { ActivatedRoute, Router } from '@angular/router'
import * as moment from 'moment'

import { NestedTreeControl } from '@angular/cdk/tree'
import { MatDialog } from '@angular/material/dialog'
import { MatTreeNestedDataSource } from '@angular/material/tree'
import { Subscription } from 'rxjs'
import { AuthorizationService } from '../../../../access/shared/authorization/authorization.service'
import { Permissions } from '../../../../access/shared/authorization/permissions'
import { NotificationService } from '../../../../notification/shared/notification.service'
import { OfflineService } from '../../../../shared/offline.service'
import { CommandeSettingsArticles, CommandeSettingsCoeff, CommandeSettingsDeliveries } from '../../../settings/commande-param/commande-param-settings/shared/commande-param-settings'
import { CommandeParamSettingsService } from '../../../settings/commande-param/commande-param-settings/shared/commande-param-settings.service'
import { LingerieService } from '../../../settings/commande-param/commande-param-settings/shared/lingerie.service'
import { Client } from '../../../shared/client/client'
import { ClientService } from '../../../shared/client/client.service'
import { Commande, CommandeDetails, LigneCommande } from '../../shared/commande'
import { CommandeEditDialogComponent } from '../../shared/commande-edit-dialog/commande-edit-dialog.component'
import { CommandeEditReturnDialogComponent } from '../../shared/commande-edit-return-dialog/commande-edit-return-dialog.component'
import { CommandeService } from '../../shared/commande.service'
import { Inventaire, LigneInventaire, Lingerie } from '../../shared/inventaire'
import { CommandeValidateDialogComponent } from './commande-validate-dialog/commande-validate-dialog.component'

interface InventaireNode {
  id: number
  commande: Commande
  lingerie: Lingerie
  statut: any
  date_modification: Date
  children?: InventaireNode[]
}

@Component({
  selector: 'app-commande-lingeries-edit',
  templateUrl: './commande-lingeries-edit.component.html',
  styleUrls: ['./commande-lingeries-edit.component.scss']
})
export class CommandeLingeriesEditComponent implements OnInit, OnDestroy {

  commandeSettingsArticles: CommandeSettingsArticles[]
  commandeDetails: CommandeDetails
  commandeId: string

  loading: boolean = false
  currentClient: Client
  isSelected: boolean = true

  curDay: string
  curDayNumber: number = 1
  curDayMultiplier: CommandeSettingsDeliveries[] = []

  coefficient: CommandeSettingsCoeff
  commandeSettingsDeliveries: CommandeSettingsDeliveries[]
  enabledConditionnement: boolean = false
  enabledCoeff: boolean = false

  jourLingerieDotationList: Inventaire[] = []

  treeControl = new NestedTreeControl<InventaireNode>(node => node.children)
  dataSource = new MatTreeNestedDataSource<Inventaire>()

  isOnline: boolean = true

  dotationsJour

  subClient: Subscription

  constructor(
    private commandeSettingsService: CommandeParamSettingsService,
    private clientService: ClientService,
    private commandeService: CommandeService,
    private snackBar: MatSnackBar,
    private router: Router,
    private notificationService: NotificationService,
    private lingerieService: LingerieService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private authService: AuthorizationService,
    private offlineService: OfflineService
  ) {
    moment().locale('fr')
    this.offlineService.isOnline().subscribe(res => this.isOnline = res)
  }

  hasChild = () => true

  ngOnInit(): void {
    this.subClient = this.clientService.getCurrentClient().subscribe(client => {
      this.currentClient = client
      this.route.queryParams.subscribe(params => {
        this.commandeId = params.id
        this.getCommandeDetails(this.currentClient, this.commandeId)
      })
    })

  }

  getCommandeDetails(currentClient: Client, commandeId: string) {
    this.loading = true
    this.commandeService.getCommandeDetails(commandeId).subscribe(async data => {
      this.commandeDetails = data
      this.getClientDeliveries();
      this.getDotations(currentClient.id, commandeId)
      if (this.isSendable() && !this.authService.hasPermission(Permissions.ROLE_HEBERGEMENT_LINGERE)) {
        this.reloadData(false)
      }
      this.getArticles(this.currentClient)
    }
    )
  }

  getDotations(clientId, commandeId) {
    let day = 0
    if (this.currentClient.is_comptage_jour) {
      day = (new Date(this.commandeDetails.date_livraison)).getDay()
    }
    this.commandeService.getClientDotationsJour(clientId, day).subscribe(data => {
      this.dotationsJour = data
      this.getInventaires(commandeId)
    })
  }

  getInventaires(commandeId) {
    this.commandeService.getInventairesCommande(commandeId).subscribe(inventaires => {
      this.dataSource.data = inventaires.sort((a, b) => a.lingerie.libelle > b.lingerie.libelle ? 1 : -1)

      this.dataSource.data.forEach(inventaire => {
        let dotationsLingerie = this.dotationsJour.find(value => value.lingerie.id == inventaire.lingerie.id)
        if (dotationsLingerie && dotationsLingerie.dotations.length > 0) {
          dotationsLingerie.dotations.forEach(value => {
            let article = value.article
            let dotationValue = this.getDotation(value.quantite)
            let indexArticle = inventaire.inventaire_lignes.findIndex(ligne => ligne.article.id === article.id)
            if (indexArticle == -1) {
              let articleObj = { id: article.id, designation: article.designation }
              inventaire.inventaire_lignes.push({ article: articleObj, dotation: dotationValue, restant: null, qte_commande: 0 })
            } else {
              if (!this.isSendable()) {
                inventaire.inventaire_lignes[indexArticle].dotation = dotationValue
              }
            }

          })
        }

        if (this.isSendable()) {
          this.enabledCoeff = inventaire.enabled_coeff ?? false
        } else {
          this.enabledCoeff = this.currentClient.enabled_coeff ?? false
        }
      })
      this.loading = false
    })
  }

  getArticles(client: Client) {
    this.commandeSettingsService.getCommandSettingsArticles(client.id).subscribe(data => {
      this.commandeSettingsArticles = data
      this.getClientCoefficient()
    })
  }

  ngOnDestroy() {
    this.snackBar.dismiss()
    if (this.subClient) {
      this.subClient.unsubscribe()
    }
  }

  getClientCoefficient() {
    this.commandeSettingsService.getCommandMaxOrderRatio(this.currentClient.id).subscribe(
      (data) => {
        this.coefficient = data
      })
  }

  getDayMultiplier() {
    if (this.currentClient.is_comptage_lingerie && this.currentClient.is_comptage_jour) {
      return 1
    }
    this.curDayMultiplier = this.commandeSettingsDeliveries.filter(coef => coef.jrs_relivraison_lp === moment(this.commandeDetails.date_livraison).day())
    if (!('multiple_mab_jour' in this.curDayMultiplier[0]) || this.curDayMultiplier[0].multiple_mab_jour === 0) {
      return 1
    } else {
      return this.curDayMultiplier[0].multiple_mab_jour
    }
  }

  updateInventaire(ligne: LigneInventaire, event: any) {
    if (!ligne.dotation) {
      if (event.target.value > 0) {
        this.notificationService.notif("Quantité saisie supérieure à la dotation", 'warn')
      }
      event.target.value = 0
    }
    else if (+event.target.value > ligne.dotation) {
      event.target.value = ligne.dotation
      this.notificationService.notif("Quantité saisie supérieure à la dotation", 'warn')
    }
    else if (+event.target.value < 0) {
      event.target.value = 0
    }
    ligne.restant = event.target.value !== "" ? +event.target.value : null
    ligne.qte_commande = ligne.restant != null ? ligne.dotation - ligne.restant : 0
  }

  omit_not_number(e) {
    var k
    document.all ? k = e.keyCode : k = e.which
    return ((k > 96 && k < 106) || k == 8 || k == 32 || (k >= 48 && k <= 57))
  }

  getClientDeliveries() {
    this.commandeSettingsService.getCommandDeliveries(this.currentClient.id).subscribe(
      (data) => {
        this.commandeSettingsDeliveries = data
        this.getClientConditionnement()
      }
    )
  }

  refuse() {
    this.loading = true
    this.commandeService.getCommandeDetails(this.commandeId).subscribe(data => {
      if (data.statut.code == "DD") {
        this.commandeDetails = data
        let dialogRef = this.dialog.open(CommandeEditReturnDialogComponent)
        dialogRef.afterClosed().subscribe(value => {
          this.loading = false
        })
      } else {
        this.loading = false
        this.router.navigate(['/escli/linge-hebergement/list'])
      }
    })
  }

  getDotation(value) {
    let coeff = this.currentClient.enabled_coeff ? this.coefficient?.coeff_max_commande : 1
    return Math.ceil(+(this.getDayMultiplier() * value * coeff))
  }

  openDialog(): void {
    if (!this.isOnline) {
      this.notificationService.notif("Vous ne pouvez pas valider l'inventaire en Mode Hors Ligne", "warn")
    } else {
      if (this.dataSource.data.every(inventaire => inventaire.statut['code'] == 'R')) {
        const dialogRef = this.dialog.open(CommandeValidateDialogComponent, {
          data: { commandeId: this.commandeId }
        })
        dialogRef.beforeClosed().subscribe(result => {
          if (result) {
            this.notificationService.notif("Les inventaires ont été validés", "notif")
            this.getCommandeDetails(this.currentClient, this.commandeId)
          } else {
            this.router.navigate(['/escli/linge-hebergement/list']).then(() => {
              this.notificationService.notif("Le délai est dépassé pour valider ces inventaires", "error")
            })
          }
        })
      } else {
        this.notificationService.notif("Vous ne pouvez pas valider les inventaires car ils ne sont pas tous renseignés", "warn")
      }
    }
  }

  getClientConditionnement() {
    this.commandeSettingsService.getCommandConditionnement(this.currentClient.id).subscribe(data => {
      this.enabledConditionnement = data?.enabled_conditionnement ?? false
      this.loading = false
    })
  }

  getJourLingerieDotation(lingerie) {
    if (this.jourLingerieDotationList.length > 0) {
      let dotations = this.jourLingerieDotationList.filter(value => value.lingerie.id == lingerie.id)

      if (dotations.length > 0) {
        return dotations[0].inventaire_lignes
      }
    }
    return []
  }

  saveInventaire(inventaire) {
    if (!this.isOnline) {
      this.notificationService.notif("L'inventaire de la lingerie " + inventaire.lingerie.libelle + " va être enregistré automatiquement quand vous serez en ligne", "warn", 6000)
    }

    this.offlineService
      .isOnlinePromise()
      .then(res => {
        if (res) {
          inventaire.enabled_coeff = this.currentClient.enabled_coeff
          this.commandeService.postInventaire(inventaire).subscribe(data => {
            inventaire.statut = data.statut
            this.notificationService.notif("L'inventaire de la lingerie " + inventaire.lingerie.libelle + " a été enregistré", "notif")
          })
        }
      })
  }

  reloadData(selected: boolean) {
    this.isSelected = selected
  }

  isSendable() {
    return (this.commandeDetails?.statut.code == 'AT' || this.commandeDetails?.statut.code == 'AT12H')
  }

  updateCommande(ligne: LigneCommande, articleId, event: any) {
    let max = this.getSommeDotationsArticle(articleId)
    if (!max) {
      if (event.target.value > 0) {
        this.notificationService.notif("Quantité saisie supérieure au maximum commandable", 'warn')
      }
      event.target.value = 0
    }
    else if (+event.target.value > max) {
      event.target.value = max
      this.notificationService.notif("Quantité saisie supérieure au maximum commandable", 'warn')
    }
    else if (+event.target.value < 0) {
      event.target.value = 0
    }
    ligne.quantite = event.target.value !== "" ? +event.target.value : null
  }

  saveCommande() {
    this.loading = true
    this.commandeService.getCommandeDetails(this.commandeId).subscribe(data => {
      if (data.statut.code !== "T" && data.statut.code !== "DD" && data.statut.code !== "T0") {
        this.commandeDetails.lod_ligne_commandes.forEach(ligne => {
          let article = {
            article: ligne.article.id,
            quantite: ligne.quantite,
            preCommande: ligne.preCommande,
          }
          this.commandeService.updateCommandeDetails(this.commandeId, this.currentClient.id, ligne.id, article).subscribe()
        })
        this.commandeService.updateStatus(this.commandeId, this.currentClient).subscribe(status => {
          this.loading = false
          this.router.navigate(['/escli/linge-hebergement/list']).then(() => {
            this.notificationService.notif("Commande mise à jour", "notif")
          })
        }, error => { this.loading = false })
      } else {
        if (data.statut.code == "DD") {
          this.commandeDetails = data
          this.notificationService.notif("Le délai de commande est dépassé, vous avez jusqu'à 12h30 pour cliquer sur 'Enregistrer & Transmettre'", "error")
        } else {
          this.router.navigate(['/escli/linge-hebergement/list']).then(() => {
            this.notificationService.notif("Commande déjà transmise", "error")
          })
        }
      }
      this.loading = false
    })
  }

  openDialogSend(): void {
    this.loading = true
    let dialogRef = this.dialog.open(CommandeEditDialogComponent, {
      data: { lod_ligne_commandes: this.commandeDetails.lod_ligne_commandes, commandeId: this.commandeId, currentClient: this.currentClient }
    })
    dialogRef.afterClosed().subscribe(value => {
      this.loading = false
    })
  }

  getConditionnement(article) {
    let article_el = this.commandeSettingsArticles.find(art => art.article.id == article.id)
    if (article_el) {
      return article_el.qte_conditionnement
    }
    return null
  }

  getQteStock(article) {
    let article_el = this.commandeSettingsArticles.find(art => art.article.id == article.article.id)
    if (article_el) {
      return article_el.qte_stock
    }
    return null
  }

  getSommeDotationsArticle(articleId) {
    let sommeDotations = 0
    this.dataSource.data.forEach(inventaire => {
      let ligne = inventaire.inventaire_lignes.find(el => el.article.id == articleId)
      if (ligne) {
        sommeDotations += ligne.dotation
      }
    })
    return sommeDotations
  }

  haveQteStock(ligne) {
    let qte_stock = this.getQteStock(ligne);
    return qte_stock && qte_stock > 0
  }

  isDisabled(ligne) {
    if(!this.haveQteStock(ligne)) {
      ligne.restant = 0
    }
    return this.isSendable() || !this.haveQteStock(ligne)
  }
}
